module.exports = __webpack_public_path__ + "1fc418e33fd5a687290258b23fac4e98.png";


//////////////////
// WEBPACK FOOTER
// ../~/datatables/media/images/sort_desc.png
// module id = 1188
// module chunks = 3